const SAFE_PROTOCOLS = new Set(['https:', 'http:', 'mailto:']);

/**
 * A link target built from data (an API field, model output, a source's profile URL): returns the URL only
 * when it is absolute http(s), mailto, or a same-origin path (`/api/v1/…`), otherwise null. `javascript:`,
 * `data:`, `vbscript:`, protocol-relative `//host` and bare words never reach an `href`, so a stored value
 * cannot run script or leave the origin unannounced when clicked.
 *
 * Render the link only when this returns a value; never fall back to the raw string.
 */
export function safeHref(value: string | null | undefined): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (/^\/(?![/\\])/.test(trimmed)) return trimmed;
  try {
    const url = new URL(trimmed);
    return SAFE_PROTOCOLS.has(url.protocol) ? url.toString() : null;
  } catch {
    return null;
  }
}
